// Mirrors Tp_Communication.Enum.InvoiceAutomationRunOutcomeTextEnum — keep in sync.
const InvoiceAutomationRunOutcomeEnum = {
  Running: 'Running',
  Succeeded: 'Succeeded',
  Failed: 'Failed',
};

export default InvoiceAutomationRunOutcomeEnum;
